<template>
    <button type="button" class="btn btn-sm btn-outline-dark mb-3" @click="openCreateModal()">
        <i class="fas fa-plus"></i> Nouveau type
    </button>

    <DataTableBackend :url="'/api/' + table" :columns="columns" :table="table" :perPage="6">
        <template #action_btns=slotProps>
            <button class="btn btn-sm btn-light m-1" @click="openShowModal(slotProps.data)">
                <i class="fa-solid fa-ellipsis"></i>
            </button>
        </template>
    </DataTableBackend>
</template>
    
<script>
import { defineComponent, defineAsyncComponent } from 'vue';
const CreateType = defineAsyncComponent(() => import('./CreateType.vue'));
const EditType = defineAsyncComponent(() => import('./EditType.vue'));

export default defineComponent({
    data() {
        return {
            table: 'types_vehicules',
            isLoading: false,
            columns: [
                {
                    key: 'id',
                    label: 'ID',
                    exportable: true
                },
                {
                    key: 'libelle',
                    label: 'libelle',
                    exportable: true
                },
            ]
        }
    },

    methods: {
        openCreateModal() {
            this.$dialog.open(CreateType, {
                props: {
                    header: "Nouveau type",
                    style: {
                        width: '30vw'
                    },
                    modal: true
                }
            });
        },
        openEditModal(objData) {
            this.$dialog.open(EditType, {
                props: {
                    header: "Type N°" + objData.id,
                    style: {
                        width: '30vw'
                    },
                    modal: true
                },
                data: objData
            });
        }
    }
})
</script>